import React, { Component } from 'react';

export class About extends Component {
  static displayName = About.name;

  render () {
    return (
      <div>
        <section className="hero-about">
  <div className="text">
    <h1 title="Swami Brahmanand Saraswati">“जिस ज्ञान का जन्म मौन में होता है, वही सम्पूर्ण जगत को प्रकाश प्रदान करता है।”</h1>
    <p>
      सनातन धर्म वह शाश्वत मार्ग है जहाँ सत्य, साधना, करुणा और प्रेम एक साथ प्रवाहित होते हैं।
      हमारे पूज्य गुरुजन अपने जीवन से यह सिखाते रहे कि आत्मिक जागरण केवल ग्रंथों में नहीं,
      बल्कि हर श्वास, हर कर्म और हर क्षण की जागरूकता में निहित है। उनकी दिव्य कृपा आज भी
      अनगिनत साधकों के लिए मार्गदर्शक है।
    </p>
  </div>

  <div className="guru-image">
    <div className="aura"></div>
    <img src="images/guruji_photo.jpg" alt="Sanatan Dharma Guru" title="Swami Brahmanand Saraswati" />
  </div>
</section>

{/* ABOUT */}
<section className="about-section">
  <h2 title="Sanatan Dharm Guru Swami Brahmanand Saraswati ">सनातन धर्म के बारे में</h2>
  <p>
    सनातन धर्म — अर्थात शाश्वत, अनादि–अनंत सत्य — केवल एक धर्म नहीं, बल्कि जीवन का वह
    सिद्धांत है जो समस्त सृष्टि में व्याप्त है। यह धर्म कर्म, कर्तव्य, प्रेम, करुणा, ज्ञान और मुक्ति
    जैसे सार्वभौमिक सिद्धांतों पर आधारित है। हिमालय की तपोभूमियों से लेकर दक्षिण के देवालयों
    तक, ऋषियों और महापुरुषों ने इस दिव्य ज्ञान को पीढ़ी दर पीढ़ी सुरक्षित रखा। सनातन का मूल
    संदेश यही है — “सत्य भीतर है, ईश्वर भीतर है, और मुक्ति भी भीतर ही है।”
  </p>
</section>

{/* LINEAGE */}
<section className="lineage">
  <h2 title="Swami Brahmanand Saraswati">स्वामी ब्रह्मानंद सरस्वती जी महाराज के आध्यात्मिक शिष्य</h2>

  <div className="guru-grid">
    <div className="guru-card">
      <img
        src="images/PremanandSaraswatiJiMaharaj.jpg"
        alt="Premanand Saraswati Maharaj" title="Premanand Saraswati Maharaj"
      />
      <h4>महामंडलेश्वर श्री प्रेमानंद सरस्वती जी</h4>
      <p>
        महामंडलेश्वर श्री प्रेमानंद सरस्वती जी ज्योतिर्मठ की गौरवशाली आध्यात्मिक परंपरा के प्रतिष्ठित आचार्य हैं। उनका जीवन तप, त्याग, ज्ञान और करुणा का समन्वय है। वे अद्वैत वेदांत और आत्मबोध के मार्ग को जीवन में उतारने पर बल देते हैं।
        <br/>
        <b>संदेश:</b> “जब अहं शांत होता है, तभी आत्मा का प्रकाश प्रकट होता है।”
      </p>
    </div>

    <div className="guru-card">
      <img
        src="images/Yati-Narsinghanand-Saraswati-Head-Priest.jpg"
        alt="Narsinghanand Saraswati" title="Narsinghanand Saraswati"
      />
      <h4>महामंडलेश्वर श्री नरसिंहा नंद सरस्वती जी</h4>
      <p>
        महामंडलेश्वर श्री नरसिंहा नंद सरस्वती जी ध्यान, संयम और आत्मचिंतन के सहज मार्ग के प्रेरक हैं। वे साधना को कठिन अनुशासन नहीं, बल्कि सहज जीवन-पद्धति के रूप में प्रस्तुत करते हैं।
        <br/>
        <b>संदेश:</b> “मन के शांत होते ही सत्य स्वयं प्रकट हो जाता है।”
      </p>
    </div>

    <div className="guru-card">
      <img
        src="images/dipankarji_maharaj.jpg"
        alt="Dipankar Ji Maharaj" title="Dipankar Ji Maharaj"
      />
      <h4>ध्यानगुरु श्री स्वामी दीपांकर जी</h4>
      <p>
        ध्यानगुरु श्री स्वामी दीपांकर जी ध्यान को आत्मजागृति का प्रभावी साधन मानते हैं। वे विज्ञान और अध्यात्म के संतुलन से मानव चेतना के विस्तार पर कार्य कर रहे हैं।
        <br/>
        <b>संदेश:</b> “अंतर्यात्रा ही बाहरी शांति का वास्तविक आधार है।”
      </p>
    </div>

    <div className="guru-card">
      <img
        src="images/Aacharya_Sudhir_Dutt_Bhardwaj2.jpg"
        alt="Aacharya Sudhir Dutt Bhardwaj" title="Aacharya Sudhir Dutt Bhardwaj"
      />
      <h4>महान दार्शनिक ज्योतिर्विद आचार्य डॉ श्री सुधीर दत्त भारद्वाज जी</h4>
      <p>
        डॉ. श्री सुधीर दत्त भारद्वाज जी दर्शन, ज्योतिर्विद और ध्यान-परंपरा के मर्मज्ञ हैं। वे भारतीय ज्ञान-परंपरा को आधुनिक संदर्भों से जोड़ते हैं।
        <br/>
        <b>संदेश:</b> “ज्ञान वही है जो जीवन में विवेक और करुणा दोनों उत्पन्न करे।”
      </p>
    </div>

    <div className="guru-card">
      <img
        src="images/Aacharya_Saurabh.jpg"
        alt="Aacharya Saurabh" title="Aacharya Saurabh"
      />
      <h4>विद्वान श्री आचार्य सौरभ जी</h4>
      <p>
        विद्वान श्री आचार्य सौरभ जी शास्त्र-अध्ययन और ध्यान-मार्ग को सामान्य जन तक पहुँचाने में सक्रिय हैं। वे सरल भाषा में गूढ़ विषयों को स्पष्ट करने के लिए जाने जाते हैं।
        <br/>
        <b>संदेश:</b> “साधना वही है जो जीवन को सरल और हृदय को निर्मल बनाए।”
      </p>
    </div>

    <div className="guru-card">
      <img
        src="images/AnkitJI.jpg"
        alt="Mehant Ankit Janeshwarand Saraswati" title="Mehant Ankit Janeshwarand Saraswati"
      />
      <h4>महंत स्वामी श्री अंकित जनेश्वरानंद सरस्वती जी</h4>
      <p>
        महंत स्वामी श्री अंकित जनेश्वरानंद सरस्वती जी आश्रम-परंपरा के अनुशासित साधक एवं सेवक हैं। वे संगठन, सेवा और साधना के माध्यम से सनातन मूल्यों को सुदृढ़ कर रहे हैं।
        <br/>
        <b>संदेश:</b> “सेवा में समर्पण और साधना में अनुशासन ही धर्म का आधार है।”
      </p>
    </div>

    <div className="guru-card">
      <img
        src="images/Himanshu.jpg"
        alt="Tatvaranya" title="Tatvaranya"
      />
      <h4>स्वामी श्री तत्वारण्य</h4>
      <p>
        स्वामी श्री तत्वारण्य जी आत्मचिंतन, ध्यान और संतुलित जीवन के प्रेरक हैं। वे आंतरिक शांति को आध्यात्मिक प्रगति का मूल मानते हैं।
        <br/>
        <b>संदेश:</b> “जब भीतर संतुलन होता है, तब जीवन स्वयं साधना बन जाता है।”
      </p>
    </div>
  </div>
</section>

{/* TEACHINGS */}
<section className="teachings">
  <h2>मुख्य शिक्षाएँ</h2>

  <div className="teachings-grid">
    <div className="teaching-card">
      <h4>आत्मा–परमात्मा का एकत्व</h4>
      <p>
        सनातन धर्म का मूल सार यह है कि आत्मा और परमात्मा भिन्न नहीं — एक ही चेतना के विभिन्न
        स्वरूप हैं। जब साधक इस सत्य को अनुभव करता है, तभी उसके भीतर वास्तविक स्वतंत्रता,
        आनंद और शांति का उदय होता है।
      </p>
    </div>

    <div className="teaching-card">
      <h4>धर्मयुक्त आचरण</h4>
      <p>
        धर्म केवल पूजा–पाठ नहीं, बल्कि वह आचरण है जो हर स्थित‍ि में सत्य, संतुलन, न्याय और
        करुणा को बनाए रखता है। धर्मयुक्त कर्म मनुष्य को भीतरी समरसता और बाहरी सफलता
        — दोनों प्रदान करता है।
      </p>
    </div>

    <div className="teaching-card">
      <h4>गुरु–शिष्य परंपरा</h4>
      <p>
        गुरु वह दिव्य प्रकाश हैं जो अज्ञान के अंधकार को दूर कर साधक को आत्मसाक्षात्कार की
        ओर ले जाते हैं। सनातन की गुरु–शिष्य परंपरा ज्ञान का आदान–प्रदान नहीं, बल्कि
        अनुभव, श्रद्धा और दिव्य ऊर्जा का पवित्र प्रवाह है।
      </p>
    </div>
  </div>
</section>

      </div>
    );
  }
}